import { OverheadReachFSM } from './OverheadReachFSM';
import { ArmAbductionFSM } from './ArmAbductionFSM';
import { BicepCurlFSM } from './BicepCurlFSM';
import { RowFSM } from './RowFSM';
import { CoreTwistFSM } from './CoreTwistFSM';
import { LateralCoreFlexionFSM } from './LateralCoreFlexionFSM';
import { CrossBodyPunchFSM } from './CrossBodyPunchFSM';
import { ExerciseType } from '../ExerciseDetection';
import { ArmAbductionFrontFSM } from './ArmAbductionFrontFSM';
import { SeatedKneeExtensionsFSM } from './SeatedKneeExtensionsFSM';
import { SeatedMarchesFSM } from './SeatedMarchesFSM';

// FSM instances for each exercise type
const fsmInstances = {};

// Initialize FSM instances
export function initializeExerciseFSMs() {
  // Initialize Overhead Reach FSM
  fsmInstances[ExerciseType.OVERHEAD_REACH] = new OverheadReachFSM();
  fsmInstances[ExerciseType.ARM_ABDUCTION] = new ArmAbductionFSM();
  fsmInstances[ExerciseType.BICEP_CURL] = new BicepCurlFSM();
  fsmInstances[ExerciseType.ROW] = new RowFSM();
  fsmInstances[ExerciseType.CORE_TWIST] = new CoreTwistFSM();
  fsmInstances[ExerciseType.LATERAL_CORE_FLEXION] = new LateralCoreFlexionFSM();
  fsmInstances[ExerciseType.CROSS_BODY_PUNCH] = new CrossBodyPunchFSM();
  fsmInstances[ExerciseType.ARM_ABDUCTION_FRONT] = new ArmAbductionFrontFSM();
  fsmInstances[ExerciseType.SEATED_KNEE_EXTENSIONS] = new SeatedKneeExtensionsFSM();
  fsmInstances[ExerciseType.SEATED_MARCHES] = new SeatedMarchesFSM();
  
}

// Check if FSM is available for a given exercise type
export function hasFSMImplementation(exerciseType) {
  return !!fsmInstances[exerciseType];
}

// Get the FSM instance for a given exercise type
export function getFSMInstance(exerciseType) {
  return fsmInstances[exerciseType];
}

// Process exercise data using FSM
export function processFSM(exerciseType, results, timestamp) {
  const fsm = fsmInstances[exerciseType];
  if (!fsm) {
    throw new Error(`No FSM implementation for exercise type: ${exerciseType}`);
  }
  
  return fsm.process(results, timestamp);
}

// Reset repetition count for an exercise
export function resetFSMRepetitionCount(exerciseType) {
  const fsm = fsmInstances[exerciseType];
  if (fsm) {
    fsm.setRepetitionCount(0);
  }
}

// Get repetition count from FSM
export function getFSMRepetitionCount(exerciseType) {
  const fsm = fsmInstances[exerciseType];
  if (!fsm) return 0;
  
  return fsm.getRepetitionCount();
}

export function analyzeOverheadReachFSM(results, timestamp) {
  return processFSM(ExerciseType.OVERHEAD_REACH, results, timestamp);
}

export function analyzeArmAbductionFSM(results, timestamp) {
  return processFSM(ExerciseType.ARM_ABDUCTION, results, timestamp);
}

export function analyzeBicepCurlFSM(results, timestamp) {
  return processFSM(ExerciseType.BICEP_CURL, results, timestamp);
}

export function analyzeRowFSM(results, timestamp) {
  return processFSM(ExerciseType.ROW, results, timestamp);
}

export function analyzeCoreTwistFSM(results, timestamp) {
  return processFSM(ExerciseType.CORE_TWIST, results, timestamp);
}

export function analyzeLateralCoreFlexionFSM(results, timestamp) {
  return processFSM(ExerciseType.LATERAL_CORE_FLEXION, results, timestamp);
}

export function analyzeCrossBodyPunchFSM(results, timestamp) {
  return processFSM(ExerciseType.CROSS_BODY_PUNCH, results, timestamp);
}

export function analyzeSeatedKneeExtensionsFSM(results, timestamp) {
  return processFSM(ExerciseType.SEATED_KNEE_EXTENSIONS, results, timestamp);
}

export function analyzeSeatedMarchesFSM(results, timestamp) {
  return processFSM(ExerciseType.SEATED_MARCHES, results, timestamp);
}

export function setBicepCurlFSMActiveSide(side) {
  const fsm = fsmInstances[ExerciseType.BICEP_CURL];
  if (fsm) {
    fsm.setActiveSide(side);
  }
}

export function setCrossBodyPunchFSMActiveSide(side) {
  const fsm = fsmInstances[ExerciseType.CROSS_BODY_PUNCH];
  if (fsm) {
    fsm.setActiveSide(side);
  }
}

export function setSeatedKneeExtensionsFSMActiveLeg(leg) {
  const fsm = fsmInstances[ExerciseType.SEATED_KNEE_EXTENSIONS];
  if (fsm) {
    fsm.setActiveLeg(leg);
  }
}

export function setSeatedMarchesFSMActiveLeg(leg) {
  const fsm = fsmInstances[ExerciseType.SEATED_MARCHES];
  if (fsm) {
    fsm.setActiveLeg(leg);
  }
} 